import { render, staticRenderFns } from "./InstanceGroupDeleteModal.vue?vue&type=template&id=51c118a2&scoped=true&"
import script from "./InstanceGroupDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./InstanceGroupDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c118a2",
  null
  
)

export default component.exports